<template>
  <v-snackbar
    v-model="showUpdatePrompt"
    :timeout="-1"
    color="primary"
    location="bottom"
  >
    <div class="d-flex align-center">
      <v-icon class="mr-2">mdi-download</v-icon>
      <span>{{ t('pwa.updateAvailable') }}</span>
    </div>
    <template v-slot:actions>
      <v-btn
        variant="text"
        @click="handleUpdate"
      >
        {{ t('common.update') }}
      </v-btn>
      <v-btn
        variant="text"
        @click="showUpdatePrompt = false"
      >
        {{ t('common.later') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRegisterSW } from 'virtual:pwa-register/vue';

const { t } = useI18n();

const { needRefresh, updateServiceWorker } = useRegisterSW({
  onRegistered(r: ServiceWorkerRegistration | undefined) {
    console.log('Service Worker registered:', r);
  },
  onRegisterError(error: Error) {
    console.error('Service Worker registration error:', error);
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

const showUpdatePrompt = computed({
  get: () => needRefresh.value,
  set: (value: boolean) => {
    if (!value) {
      needRefresh.value = false;
    }
  },
});

async function handleUpdate() {
  await updateServiceWorker(true);
}
</script>
